export default "__VITE_ASSET__CSBWcHww__"